import React from 'react';
import { LearningMode, ProgrammingLanguage } from '@unity-learning/shared';
import { useLearningMode } from '../contexts/LearningModeContext';

const ModeSwitcher: React.FC = () => {
  const { learningMode, programmingLanguage, setLearningMode, setProgrammingLanguage, isPythonJsMode } = useLearningMode();

  const modes = [
    { value: LearningMode.UNITY_CSHARP, label: 'Unity C#', disabled: false },
    { value: LearningMode.PYTHON_JS, label: 'Python / JS', disabled: false },
    { value: LearningMode.GODOT, label: 'Godot', disabled: false },
  ];

  return (
    <div className="flex flex-col items-start gap-1">
      <div className="flex items-center bg-gray-100 dark:bg-slate-800 rounded-lg p-0.5">
        {modes.map(({ value, label, disabled }) => (
          <button
            key={value}
            onClick={() => !disabled && setLearningMode(value)}
            disabled={disabled}
            className={`px-3 py-1 text-xs font-medium whitespace-nowrap rounded-md transition-all duration-200 ${
              learningMode === value
                ? 'bg-white dark:bg-slate-700 text-blue-600 dark:text-blue-400 shadow-sm'
                : disabled
                  ? 'text-gray-300 dark:text-slate-600 cursor-not-allowed'
                  : 'text-gray-500 dark:text-slate-400 hover:text-gray-700 dark:hover:text-slate-300'
            }`}
            title={disabled ? 'Bientot disponible' : label}
          >
            {label}
          </button>
        ))}
      </div>

      {isPythonJsMode && (
        <div className="flex items-center bg-gray-50 dark:bg-slate-800/50 rounded-md p-0.5 ml-1">
          <button
            onClick={() => setProgrammingLanguage(ProgrammingLanguage.PYTHON)}
            className={`px-2 py-0.5 text-xs font-medium rounded transition-all ${
              programmingLanguage === ProgrammingLanguage.PYTHON
                ? 'bg-yellow-100 dark:bg-yellow-900/30 text-yellow-700 dark:text-yellow-400'
                : 'text-gray-400 dark:text-slate-500 hover:text-gray-600 dark:hover:text-slate-300'
            }`}
          >
            Python
          </button>
          <button
            onClick={() => setProgrammingLanguage(ProgrammingLanguage.JAVASCRIPT)}
            className={`px-2 py-0.5 text-xs font-medium rounded transition-all ${
              programmingLanguage === ProgrammingLanguage.JAVASCRIPT
                ? 'bg-yellow-100 dark:bg-yellow-900/30 text-yellow-700 dark:text-yellow-400'
                : 'text-gray-400 dark:text-slate-500 hover:text-gray-600 dark:hover:text-slate-300'
            }`}
          >
            JavaScript
          </button>
        </div>
      )}
    </div>
  );
};

export default ModeSwitcher;
